import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { ApiUrlService } from '../apiUrl/api-url.service';
import { EmployeeData } from '../../api/assignment-employee/collaborator';
import { AssignmentLoan } from '../../api/assignment-employee/assignment-loan.model';

@Injectable({
    providedIn: 'root'
})
export class CollaboratorService {

    private apiUrl: string;
    private apiUrlAssignments: string;
    private apiAssignments: string;


    constructor(private http: HttpClient, private apiUrlService: ApiUrlService) {
        this.apiUrl = this.apiUrlService.apiGetEmployee();
        this.apiUrlAssignments = this.apiUrlService.apiAssignmentsData();
        this.apiAssignments = this.apiUrlService.apiAssignmentsLoanData();

    }

    getEmployeeData(employeeCode: string): Observable<EmployeeData> {
        //console.log('[CollaboratorService] getEmployeeData llamado con employeeCode:', employeeCode);
        const url = `${this.apiUrl}/${employeeCode}`;
        return this.http.get<EmployeeData>(url).pipe(
            catchError((error) => {
                console.error('Hubo un error:', error);
                throw error;
            })
        );
    }

    //mantenimiento de vehículos
    updateVehicles(id: string, data: any): Observable<any> {
        return this.http.patch(`${this.apiUrlAssignments}/${id}`, data);
    }

    //Asignación temporal
    //POST
    createLoan(assignment_id: string, body: AssignmentLoan): Observable<any> {
        return this.http.post(`${this.apiUrlAssignments}/${assignment_id}/assignment-loan`, body);
    }

    updateAssignmentLoan(id: string, data: any): Observable<any> {
        return this.http.patch(`${this.apiAssignments}/${id}`, data);
    }

    deleteAssignmentLoan(id: string): Observable<any> {
        return this.http.delete(`${this.apiAssignments}/${id}`);
    }

}
